<template>
  <div class="comparison-columns grid grid-cols-12 md:gap-5">
    <div
      v-if="compare"
      class="col-span-12"
      :class="[
        futureSituationExists
          ? 'md:col-span-5'
          : 'md:col-span-10 md:col-start-2 lg:col-span-6 lg:col-start-4',
      ]"
    >
      <h3 class="comparison-columns__title">
        {{ compare.current.title }}
      </h3>
      <p>{{ compare.current.text }}</p>
    </div>
    <div
      v-if="futureSituationExists"
      class="hidden md:block md:col-span-2 mt-1"
    >
      <comparison-arrow
        class="comparison-columns__arrow icon"
      />
    </div>
    <div
      v-if="futureSituationExists"
      class="col-span-12 md:col-span-5"
    >
      <h3 class="comparison-columns__title">
        {{ compare.future.title }}
      </h3>
      <p>{{ compare.future.text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComparisonColumns',
  components: {
    ComparisonArrow: () => import(/* webpackChunkName: "main" */ '@/components/svg/ComparisonArrow.vue'),
  },
  props: {
    compare: {
      type: Object,
      default: null,
    },
  },
  computed: {
    futureSituationExists() {
      return this.compare && typeof this.compare.future !== 'undefined';
    },
  },
};
</script>

<style lang="postcss">
.comparison-columns {
  &__title {
    @apply text-secondary-alpha mb-2;
  }

  &__arrow {
    width: 100% !important;
  }

  p {
    white-space: pre-line;
  }
}
</style>
